module.exports = __webpack_public_path__ + "static/media/1-470x490.6fd570a6.jpg";